import InterviewTable from "./InterviewTable";
export default InterviewTable;
